import React from 'react';
import { FieldArray, useFormikContext } from 'formik';
import { FormGroup } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { Input, Select, Switch } from '../../lib/form-field';
import { CONSENT_NAMES } from '../LandingPageEditor/landingComponents';
import i18n from '../LandingPageEditor/i18n';

const { getConsentDefaults } = i18n;

const PATH = 'landingComponents.shared.consents';

const ConsentsFieldArray = () => {
  const { values } = useFormikContext();
  const { t } = useTranslation();
  const consents = values.landingComponents.shared.consents || [];
  const language = values.landingComponents.shared.language;

  // Un nome già in uso sparisce dalle altre righe: impedisce i duplicati che
  // la validazione in pubblicazione rifiuterebbe comunque.
  const optionsFor = (index) =>
    CONSENT_NAMES.filter(
      (name) =>
        name === consents[index].name ||
        !consents.some((consent) => consent.name === name),
    ).map((name) => ({ value: name, label: t(name) }));

  const nextFreeName = () =>
    CONSENT_NAMES.find(
      (name) => !consents.some((consent) => consent.name === name),
    );

  return (
    <FieldArray
      name={PATH}
      render={(arrayHelpers) => (
        <FormGroup>
          {consents.map((consent, index) => (
            <div key={index} className="border rounded p-2 mb-2">
              <div className="d-flex justify-content-end align-items-center mb-2">
                <button
                  type="button"
                  className="btn btn-danger p-0"
                  style={{ width: '31px', height: '31px' }}
                  onClick={() => arrayHelpers.remove(index)}>
                  <i className="bx bx-trash d-block font-size-15" />
                </button>
              </div>
              <div className="d-flex align-items-end">
                <div className="flex-grow-1 mr-2">
                  <Select
                    name={`${PATH}.${index}.name`}
                    id={`${PATH}.${index}.name`}
                    label="Consent"
                    isMulti={false}
                    options={optionsFor(index)}
                  />
                </div>
                <div className="flex-shrink-0">
                  <Switch
                    name={`${PATH}.${index}.required`}
                    label="Required"
                  />
                </div>
              </div>
              <Input
                type="textarea"
                rows="3"
                name={`${PATH}.${index}.text`}
                id={`${PATH}.${index}.text`}
                label="Consent Text"
              />
            </div>
          ))}
          {nextFreeName() && (
            <button
              type="button"
              className="btn btn-sm btn-outline-primary"
              onClick={() => {
                const name = nextFreeName();
                arrayHelpers.push({
                  name,
                  text: getConsentDefaults(language).byName[name] || '',
                  required: false,
                });
              }}>
              <i className="bx bx-plus align-middle mr-1" />
              Add consent
            </button>
          )}
        </FormGroup>
      )}
    />
  );
};

export default ConsentsFieldArray;
